<form [formGroup]="newPasswordForm" novalidate (ngSubmit)="onSubmit()">
    <mat-card class="new-password-card">
        <h4>Set a New Password</h4>
        <mat-card-content>
            <div class="row">
                <div class="col">
                    <mat-form-field class="full-width">
                        <input matInput type="email" placeholder="Email" formControlName="email" required />
                        <mat-error *ngIf="isEmailNotValid()">
                            {{ getEmailErrorMessage() }}
                        </mat-error>
                    </mat-form-field>
                </div>
            </div>
            <div class="row">
                <div class="col">
                    <mat-form-field class="full-width">
                        <input matInput #password type="password" placeholder="Password" formControlName="password" required />
                        <mat-error *ngIf="isPasswordNotValid()">
                            {{ getPasswordErrorMessage() }}
                        </mat-error>
                    </mat-form-field>
                </div>
                <div class="col">
                    <mat-form-field class="full-width">
                        <input matInput #passwordConfirm type="password" placeholder="Password Confirmation" formControlName="passwordConfirm" required />
                        <mat-error>
                            <span *ngIf="getPasswordConfirmErrorMessage() !== ''">
                {{ getPasswordConfirmErrorMessage() }}
              </span>
                        </mat-error>
                    </mat-form-field>
                </div>
            </div>
        </mat-card-content>
        <mat-card-actions>
            <button mat-raised-button class="full-width" color="primary"  type="submit">Set new password</button>
        </mat-card-actions>
    </mat-card>
</form>